import { formatCurrency, formatNumber } from '@/shared/lib/format';

import type { PurchaseLimit } from '../types/purchase-limit.types';

/** "ILS 500.00 every 30 days" / "5 orders every 7 days". */
export function describeLimit(
  limit: Pick<PurchaseLimit, 'metric' | 'currencyCode' | 'maxAmount' | 'periodDays'>,
): string {
  const amount =
    limit.metric === 'OrderValue'
      ? formatCurrency(limit.maxAmount, limit.currencyCode ?? 'USD')
      : `${formatNumber(limit.maxAmount)} order(s)`;
  return `${amount} every ${limit.periodDays} day(s)`;
}

export function describeUsage(
  limit: Pick<PurchaseLimit, 'metric' | 'currencyCode'>,
  used: number,
): string {
  return limit.metric === 'OrderValue'
    ? formatCurrency(used, limit.currencyCode ?? 'USD')
    : `${formatNumber(used)} order(s)`;
}
